import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import vi from './locales/vi.json';
import zh from './locales/zh.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ja: { translation: ja },
  ko: { translation: ko },
  vi: { translation: vi },
  zh: { translation: zh },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

const mapCountryToLanguage = (countryCode?: string) => {
  switch ((countryCode || '').toUpperCase()) {
    case 'CN':
    case 'TW':
    case 'HK':
    case 'MO':
      return 'zh';
    case 'VN':
      return 'vi';
    case 'JP':
      return 'ja';
    case 'KR':
      return 'ko';
    case 'FR':
      return 'fr';
    case 'US':
    case 'GB':
    case 'AU':
    case 'CA':
    case 'SG':
    case 'MY':
    case 'PH':
    case 'IN':
      return 'en';
    default:
      return 'en';
  }
};

const hasStoredLanguage = () => {
  try {
    return Boolean(window.localStorage.getItem('userSelectedLanguage'));
  } catch {
    return false;
  }
};

const setLanguageByIP = async () => {
  if (hasStoredLanguage()) return;

  try {
    const response = await fetch('https://ipapi.co/json/');
    if (!response.ok) {
      i18n.changeLanguage('vi');
      return;
    }

    const data = (await response.json()) as { country_code?: string };
    if (!data?.country_code) {
      i18n.changeLanguage('vi');
      return;
    }

    const lng = mapCountryToLanguage(data.country_code);
    i18n.changeLanguage(lng);
  } catch {
    i18n.changeLanguage('vi');
  }
};

setLanguageByIP();

export default i18n;